import { Text } from '@/components/ui/Text'
import { cn } from '@/lib/utils'

import {
  artifactDisplayLabel,
  localizeArtifactCategory,
} from './artifactDisplayLabel'
import { ThreadArtifactItem } from './collectThreadArtifacts'

export interface ArtifactCategoryTitleProps {
  item: ThreadArtifactItem
  className?: string
  testId?: string
}

/**
 * Renders `{category}` in semibold, then `: {headline}`.
 *
 * The helper returns parts, not a string — a truncating `Text` cannot bold
 * a substring inside one concatenated label.
 */
export function ArtifactCategoryTitle(props: ArtifactCategoryTitleProps) {
  const { item, className, testId } = props
  const label = artifactDisplayLabel(item)
  const categoryText = localizeArtifactCategory(label.category, label.letter)

  if (label.category === null) {
    return (
      <Text
        as="span"
        size="sm"
        className={cn('min-w-0 flex-1 truncate', className)}
        data-testid={testId}
      >
        {label.headline}
      </Text>
    )
  }

  return (
    <Text
      as="span"
      size="sm"
      className={cn('min-w-0 flex-1 truncate', className)}
      data-testid={testId}
    >
      <Text as="span" size="sm" weight="semibold">
        {categoryText}
      </Text>
      {`: ${label.headline}`}
    </Text>
  )
}
